export default __webpack_public_path__ + "static/media/IMG_20210224_140420 1.286c3d5e.png";